// src/components/admin_panel/SourceGroupMappingsNeedsReview.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { adminApi } from "../../services/adminApi";

// Shared between AdminSubscriptions.js and AdminMeetupGroupFinance.js - both
// depend on source_group being correctly mapped to a real Meetup group (see
// models.SourceGroupMapping), so both show this same callout when some
// referral tags still need a human to confirm/correct their mapping. Uses
// the cheap needs-review-summary endpoint (a DB read, no Stripe scan or
// re-matching) so mounting this on two tabs' every load stays free.
function SourceGroupMappingsNeedsReview({ adminToken }) {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    if (!adminToken) return;
    let cancelled = false;
    adminApi.getSourceGroupMappingsNeedsReview(adminToken)
      .then((data) => { if (!cancelled) setSummary(data); })
      .catch((err) => console.error("Error fetching source group mappings needs-review summary:", err));
    return () => { cancelled = true; };
  }, [adminToken]);

  if (!summary || summary.needs_review_count === 0) return null;

  return (
    <div style={{
      color: "#92400e",
      marginBottom: "1rem",
      fontSize: "0.85rem",
      background: "#fef3c7",
      border: "1px solid #f59e0b",
      borderRadius: "8px",
      padding: "10px 14px",
      maxWidth: "820px",
    }}>
      ⚠️ <strong>{summary.needs_review_count} referral tag{summary.needs_review_count === 1 ? "" : "s"}</strong>{" "}
      couldn't be confidently matched to a real Meetup group: {summary.source_groups.join(", ")}.
      Subscriptions using these show up under their raw tag rather than a real group's figures until
      reviewed.{" "}
      <Link to="?tab=meetupGroupMappings" style={{ color: "#92400e", fontWeight: 700 }}>
        Review mappings →
      </Link>
    </div>
  );
}

export default SourceGroupMappingsNeedsReview;
